/** Editorially selected connections, not category-wide keyword matching. */
interface ArticleServiceLink {
  context: string;
  linkText: string;
  href: string;
  heading: string;
  description: string;
  cta: string;
}

export const articleServiceLinks: Record<string, ArticleServiceLink> = {
  "oem-co-op-marketing-leaving-money-table": {
    context: "When co-op requirements, budgets, and vendor responsibilities need one accountable owner, explore our",
    linkText: "Fractional CMO support for dealerships",
    href: "/fractional-cmo",
    heading: "Put your co-op activity inside a coordinated marketing plan.",
    description: "See how senior marketing leadership can help organize budgets, vendor responsibilities, and review priorities. Eligibility and reimbursement remain subject to your OEM's rules.",
    cta: "Explore Fractional CMO support",
  },
  "dealer-marketing-capacity-before-campaign-calendar": {
    context: "If your campaign calendar needs to reflect staffing, inventory, and follow-up capacity, our",
    linkText: "Fractional CMO services",
    href: "/fractional-cmo",
    heading: "Build a marketing plan your dealership can execute.",
    description: "Explore leadership support that brings your team, vendors, budget, and operating priorities into the same conversation.",
    cta: "See how Fractional CMO support works",
  },
  "multi-touch-attribution-auto-buyer-journey": {
    context: "To turn attribution questions into a practical reporting scope, explore",
    linkText: "custom dealership marketing reports and dashboards",
    href: "/services/custom-reporting",
    heading: "Make your marketing reports useful for decisions.",
    description: "Start with the questions your leadership team needs answered. We review available data, permissions, and measurement limits before defining a reporting project.",
    cta: "Explore custom reporting",
  },
  "vinsolutions-connect-reports-action": {
    context: "For a broader view alongside your CRM reports, explore",
    linkText: "Relevant Intelligence dealership analytics",
    href: "/relevant-bi",
    heading: "Bring your reporting questions into one conversation.",
    description: "See how Relevant Intelligence brings supported marketing and website data into an executive view. Review connection availability and data requirements with us before choosing an approach.",
    cta: "Explore Relevant Intelligence",
  },
  "elead-crm-process-show-rate": {
    context: "Software workflows need consistent human follow-through. Explore our",
    linkText: "BDC process and team training",
    href: "/services/training",
    heading: "Give your BDC team a process they can put into practice.",
    description: "Explore in-store and online training focused on customer conversations, appointment handling, and accurate CRM records—supported by our trainer's 30 years of automotive experience.",
    cta: "Explore BDC training",
  },
  "server-side-gtm-dealer-websites": {
    context: "Tracking architecture still needs a clear consent approach. Explore our",
    linkText: "Website User Consent Tool",
    href: "/dealership-website-consent-tool",
    heading: "Make consent part of your measurement plan.",
    description: "Explore branded consent preferences and configured tracking controls. Server-side tracking is not a substitute for consent or a way to bypass a visitor's choices.",
    cta: "Explore the consent tool",
  },
  "javascript-inventory-rendering-seo-acceptance-test": {
    context: "Inventory accessibility is one part of a broader search strategy. Explore our",
    linkText: "car dealership SEO and AI visibility services",
    href: "/services/seo-geo-aeo",
    heading: "Help shoppers and search engines understand your inventory.",
    description: "Explore technical site health, useful dealership content, and search accessibility. If you are considering a new website, review our custom website offering too.",
    cta: "Explore dealership SEO",
  },
  "dealer-video-service-advisor-training": {
    context: "If your dealership needs help developing clear, purposeful video content, explore our",
    linkText: "dealership video services",
    href: "/services/video",
    heading: "Start with the explanation your audience needs.",
    description: "Explore our video offering, then discuss your intended audience, the process you want to demonstrate, and the scope of production support you need.",
    cta: "Explore dealership video services",
  },
};
